export default {
    root: {
        '&&:hover': {
            backgroundColor: 'transparent',
        },
    },
};
